

const cookieName = 'STYXKEY_option';

function setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
}

function getCookie(name) {
    return document.cookie
        .split('; ')
        .find((row) => row.startsWith(name + '='))
        ?.split('=')[1];
}

function handleCookie() {
    const urlParams = new URLSearchParams(window.location.search);
    const option = urlParams.get('option');
    let cookie = getCookie(cookieName);

    // Check if cookie exists
    if (option !== null) {
        if (option.toLowerCase() === 'b') {
            setCookie(cookieName, 'b', 3650);
            cookie = 'b';
        } else {
            setCookie(cookieName, '', -1); // remove cookie
            cookie = '';
        }
    }
    return cookie;
}

function hideFields(cookie) {
    if (cookie !== 'b') return;

    document.querySelectorAll('.data-admin-field').forEach((e) => {
        e.style.display = 'none';
    });
};

document.addEventListener('DOMContentLoaded', function() {
    const cookie = handleCookie();
    hideFields(cookie);
});